import { api } from "./client";

export interface SyncStatus {
  connected: boolean;
  schema_version: string;
  last_push_at: string | null;
  last_pull_at: string | null;
  outbox_count: number;
}

export interface ConflictRead {
  id: string;
  clinic_id: string;
  entity_type: string;
  entity_id: string;
  tier: string;
  local_payload: Record<string, unknown>;
  remote_payload: Record<string, unknown>;
  status: string;
  resolution: string | null;
  detected_at: string;
  resolved_by_user_id: string | null;
  resolved_at: string | null;
}

export async function getSyncStatus(): Promise<SyncStatus> {
  const { data } = await api.get<SyncStatus>("/sync/status");
  return data;
}

export async function forceSync(): Promise<SyncStatus> {
  const { data } = await api.post<SyncStatus>("/sync/force");
  return data;
}

export async function listConflicts(
  status: "open" | "resolved" = "open",
): Promise<{ items: ConflictRead[]; total: number }> {
  const { data } = await api.get("/sync/conflicts", { params: { status } });
  return data;
}

export async function resolveConflict(
  id: string,
  resolution: "keep_local" | "keep_remote" | "merge",
  merged_payload?: Record<string, unknown>,
): Promise<ConflictRead> {
  const { data } = await api.post<ConflictRead>(`/sync/conflicts/${id}/resolve`, {
    resolution,
    merged_payload,
  });
  return data;
}
